import uuid from "react-uuid";
import { eye, git } from "../utils/Icons";
import react1 from "../img/react1.png";
import react2 from "../img/react2.png";
import react3 from "../img/react3.png";
import js1 from "../img/js1.png";
import js2 from "../img/js2.png";
import admin from "../img/admin.png";
import anistore from "../img/anistore.png";
import article from "../img/article.png";
import crypto from "../img/crypto.png";
import messenger from "../img/messenger.png";
import palette from "../img/palette.png";
import piano from "../img/piano.png";
import spotify from "../img/spotify.png";
import textwave from "../img/textwave.png";
import threads from "../img/threads.png";
import youtube from "../img/youtube.png";

export const portfolios = [

  {
    id: uuid(),
    category: "Next.js Projects",
    title: "Soul Melody",
    image: spotify,
    link1: "https://github.com/NikChhillar/spotify-clone",
    link2: "https://spotify-clone-git-without-premium-nikchhillar.vercel.app/",
    icon1: git,
    icon2: eye,
  },
  {
    id: uuid(),
    category: "Next.js Projects",
    title: "The ultimate Ecommerce Admin Dashboard",
    image: admin,
    link1: "https://github.com/NikChhillar/ecommerce-admin-nextjs",
    link2: "https://ecommerce-admin-nextjs-two.vercel.app/",
    icon1: git,
    icon2: eye,
  },

  {
    id: uuid(),
    category: "Next.js Projects",
    title: "AniStore",
    image: anistore,
    link1: "https://github.com/NikChhillar/ecommerce-store-nextjs",
    link2: "https://ecommerce-store-nextjs-eight.vercel.app/",
    icon1: git,
    icon2: eye,
  },
  {
    id: uuid(),
    category: "Next.js Projects",
    title: "Threadx",
    image: threads,
    link1: "https://github.com/NikChhillar/thread-x",
    link2: "https://thread-x.vercel.app/",
    icon1: git,
    icon2: eye,
  },
  {
    id: uuid(),
    category: "Next.js Projects",
    title: "Messenger clone",
    image: messenger,
    link1: "https://github.com/NikChhillar/messenger-nextjs",
    link2: "https://messenger-nextjs-orpin.vercel.app/",
    icon1: git,
    icon2: eye,
  },
  {
    id: uuid(),
    category: "React Projects",
    title: "Youtube clone",
    image: youtube,
    link1: "https://github.com/NikChhillar/youtube-clone",
    link2: "https://youtube-clone-nikchhillar.vercel.app/",
    icon1: git,
    icon2: eye,
  },
  {
    id: uuid(),
    category: "React Projects",
    title: "Article Summarizer",
    image: article,
    link1: "https://github.com/NikChhillar/article-summarizer",
    link2: "https://moonlit-kringle-f60578.netlify.app/",
    icon1: git,
    icon2: eye,
  },


  {
    id: uuid(),
    category: "Next.js Projects",
    title: "Palette Generator",
    image: palette,
    link1: "https://github.com/NikChhillar/color-pallete-generator",
    link2: "https://color-pallete-generator-nine.vercel.app/",
    icon1: git,
    icon2: eye,
  },
  {
    id: uuid(),
    category: "Next.js Projects",
    title: "Textwave",
    image: textwave,
    link1: "https://github.com/NikChhillar/textwave",
    link2: "https://textwave.vercel.app/",
    icon1: git,
    icon2: eye,
  },

  {
    id: uuid(),
    category: "React Projects",
    title: "Crypto tracker",
    image: crypto,
    link1: "https://github.com/NikChhillar/react-crypto-app",
    link2: "https://crytpo-x-nikchhillar.vercel.app/",
    icon1: git,
    icon2: eye,
  },

  {
    id: uuid(),
    category: "JavaScript Projects",
    title: "Piano",
    image: piano,
    link1: "https://github.com/NikChhillar/Piano",
    link2: "https://nikchhillar.github.io/Piano",
    icon1: git,
    icon2: eye,
  },
  {
    id: uuid(),
    category: "React Projects",
    title: "React portfolio website",
    image: react1,
    link1: "https://github.com/NikChhillar/portfolio",
    link2: "https://github.com/NikChhillar/portfolio",
    icon1: git,
    icon2: eye,
  },

  {
    id: uuid(),
    category: "JavaScript Projects",
    title: "Word of Wisdom",
    image: js1,
    link1: "https://github.com/NikChhillar/Words-of-Wisdom",
    link2: "https://nikchhillar.github.io/Words-of-Wisdom/",
    icon1: git,
    icon2: eye,
  },
  {
    id: uuid(),
    category: "React Projects",
    title: "Anime website",
    image: react2,
    link1: "https://github.com/NikChhillar/anifluid",
    link2: "https://anifluid-l8eztlk3j-nikchhillar.vercel.app/",
    icon1: git,
    icon2: eye,
  },
  {
    id: uuid(),
    category: "React Projects",
    title: "Giphy website",
    image: react3,
    link1: "https://github.com/NikChhillar/react-gifs-project",
    link2: "https://giphy-sable.vercel.app",
    icon1: git,
    icon2: eye,
  },
  {
    id: uuid(),
    category: "JavaScript Projects",
    title: "Notes App",
    image: js2,
    link1: "https://github.com/NikChhillar/Notes-WebApp",
    link2: "https://nikchhillar.github.io/Notes-WebApp/",
    icon1: git,
    icon2: eye,
  },


];
